import React from 'react'
import {RatingsWrap} from './ratings.style.js'
import { FaStar } from 'react-icons/fa'

const Ratings = ({rating, ...restProps}) => {
    const ratingRound = Math.round(rating)
    const ratingItems = [];
    const disableRating = [];
    for(let i=1; i <= ratingRound; i++){
        ratingItems.push(<span className="rating" key={`rating-${i}`}><FaStar /></span>)
    }

    if(rating < 5){
        for(let i=1; i <= 5 - ratingRound; i++){
            disableRating.push(<span className="rating disable" key={`disable-rating-${i}`}><FaStar /></span>)
        }
    }
    return (
        <RatingsWrap {...restProps}>
            {ratingItems}
            {disableRating}
        </RatingsWrap>
    )
}

export default Ratings;
